import React, { PureComponent } from 'react';
import FormErrorMessage from '../form-error-message/form-error-message';
import './check-box.scss';

class CheckBox extends PureComponent {
  onClick = e => {
    if (this.props.isDisabled) return;
    if (e.target.tagName.toLowerCase() === 'a') {
      return;
    }
    if (this.props.isDisabled) return;
    if (this.props.multiSelect) {
      this.props.onClick(this.props.itemId);
    } else {
      this.props.onClick({
        forLabel: this.props.forLabel,
        value: !this.props.isSelected
      })
    }
  };

  render() {
    const {
      label,
      isSelected,
      component,
      supportedLinks,
      validationErrorMsg,
      isDisabled,
      isValid
    } = this.props;

    const Component = component ? component : 'div';
  
    return (
      <Component className="check-box">
        <FormErrorMessage isValid={isValid} validationErrorMsg={validationErrorMsg} />
        <span className="check-box__inner">
          <button type="button" onClick={e => this.onClick(e)}>
            <span className="check-box__box">
              {isSelected && (
                <span className="check-box__box__inner" />
              )}
            </span>
            <span className="check-box__label">
              {label}
            </span>
          </button>
          {supportedLinks && supportedLinks.map((link, idx) => (
            <span key={idx}>
              <a target="_blank" rel="noopener noreferrer" href={link.supportedLink}>{link.supportedLinkText}</a><br/>
            </span>
          ))}
        </span>
      </Component>
    );
  }
}

CheckBox.propTypes = {

};

CheckBox.defaultProps = {
  supportedLinkText: undefined
}

export default CheckBox;